export default {
  install(Vue, options) {
    Vue.prototype.i18n = window.LWTranslate;
  }
};

//this.i18n.get(...) in components.